import { Route } from '@angular/router';
import { AuthGuard } from '../app-guard';
import { Levels } from "../shared/constants/accessLevel";
import { DomainConstants } from "../shared/constants/domain-constants";
import { DashboardConfigurationWrapperComponent } from "./components/dashboard-configuration-wrapper/dashboard-configuration-wrapper.component";

export const MANAGEMENT_DASHBOARD_STATES: Array<Route> = [
    {
        path: 'management-dashboard/:terminalId',
        component: DashboardConfigurationWrapperComponent,
        canActivate: [AuthGuard],
        data: {
            permissions: [{ 'Name': DomainConstants.TerminalTypes.MANAGEMENT_DASHBOARD.Permission, 'Level': Levels.Access }]
        }
    },
    {
        path: 'dashboards/template/:mode/:dashboardId',
        component: DashboardConfigurationWrapperComponent,
        canActivate: [AuthGuard],
        data: {
            permissions: [{ 'Name': DomainConstants.TerminalTypes.MANAGEMENT_DASHBOARD.Permission, 'Level': Levels.Access }]
        }
    }
];
